<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商解冻审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">

                <div class="h-pieceCon2" style="padding:0">
                  <div class="h-formLine">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                      <h1>申诉信息</h1>
                    </div>
                    <el-form :inline="true" :model="appealData"  class="demo-ruleForm h-formbLine h-formbLine1"
                             style="margin-top: 0.4rem">
                      <el-form-item label="申诉方" class="h-elformWrap-2 table-1" prop="username">
                        <el-input :clearable="true"  v-model="appealData.username" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="渠道" class="h-elformWrap-2 table-1" prop="channelAppeal">
                        <brselect clearable category="sales_region" disabled
                                  :v="appealData.channelAppeal"
                                  v-model="appealData.channelAppeal"></brselect>
                      </el-form-item>
                      <el-form-item label="窜货方" class="h-elformWrap-2 table-1" prop="customername">
                        <el-input :clearable="true"  v-model="appealData.customername" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="用户单位" class="h-elformWrap-2 table-1">
                        <el-input :clearable="true"  v-model="appealData.userUnit" disabled></el-input>
                      </el-form-item>
                      <br>
                      <el-form-item label="型号及数量" class="h-elformWrap-2">
                        <el-input :clearable="true"  v-model="appealData.modelAndNum" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="申诉事件" class="h-elformWrap-1">
                        <el-input :clearable="true" style="width: 95%;padding-left: 20px;" :rows="5" type="textarea" v-model="appealData.appealContent"  disabled placeholder="请输入内容"></el-input>
                      </el-form-item>
                      <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>申诉资料</h1>
                      </div>
                      <el-form-item label="" class="h-elformWrap-2 table-1">
                       <div style="margin-left: 80px;color: #4a4a4a"> 1.[申诉方用户管理] 被窜用户的归属信息</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-归属信息"
                              :uploadflag="false"
                              :delflag="false"
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a"> 2.[申诉方漏斗信息] 被窜用户的交互信息或漏斗信息</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-漏斗信息"
                              :uploadflag="false"
                              :delflag="false"
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a"> 3.[窜货用户] 带有条码的产品及安装所在用户地点</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-用户地点"
                              :uploadflag="false"
                              :delflag="false"
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;width: 400px;color: #4a4a4a">4.[窜货客户] 被窜客户的名称(该用户的安装信息或发票)</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-信息发票"
                              :uploadflag="false"
                              :delflag="false"
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a">5.[窜货信息] 其他证明材料</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-其他证明"
                              :uploadflag="false"
                              :delflag="false"
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>
                      <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;" v-if="isEnd || isDetail">
                        <h1>申诉结果</h1>
                      </div>
                      <el-form-item label="申诉结论" class="h-elformWrap-2" v-if="isEnd || isDetail">
                        <el-input :clearable="true"  v-model="appealData.conclusion" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="结论附件" class="h-elformWrap-2 " v-if="isEnd || isDetail"
                                    >
                        <brupload
                            :refid="refid"
                            reftype="窜货申诉-审核附件"
                            :uploadflag="false"
                            :delflag="false"
                            :showtime="false"
                            :tpFlag = 'true'
                        >
                        </brupload>
                      </el-form-item>
                    </el-form>
                  </div>

                  <div class="bannerBox2" v-if="!isDetail">
                    <div class="h-row h-mrt1">
                      <div class="h-rowIn">
                        <div class="h-rowBox">
                          <div class="h-rowCon">
                            <div class="h-pieceIn2">
                              <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                <h1>审核信息</h1>
                              </div>
                              <div class="h-pieceCon2 ">
                                <div class="h-formLine weekplandetail11" style="position: relative;">
                                  <el-form :inline="true" :model="appealData" v-if="!isSf">
                                    <el-form-item label="审核结论" class="h-elformWrap-2 "
                                                  style="width: 45%!important;">
                                      <el-input type="areatext"
                                          v-model="appealData.auditMind2"
                                          placeholder="请输入"></el-input>
                                    </el-form-item>
                                    <el-form-item label="审核附件" class="h-elformWrap-2 "
                                                  style="width: 45%!important;">
                                        <brupload
                                            :refid="refid"
                                            reftype="窜货申诉-审核附件"
                                            uploadflag
                                            delflag
                                            :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                  </el-form>

                                  <el-form :inline="true" :model="appealData" v-if="isSf">
                                    <el-form-item label="审核意见" class="h-elformWrap-2 "
                                                  style="width: 45%!important;">
                                      <el-input type="areatext"
                                                v-model="appealData.auditMind2"
                                                placeholder="请输入"></el-input>
                                    </el-form-item>
                                  </el-form>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 <div style="text-align: center;margin-top: 0.3rem"  v-if="!isDetail">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>
                    <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)" v-if="!isQuyu && (appealData.isReject == '0' || appealData.isReject == null)">驳回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>
                    <el-button class="h-btn h-bBtn" @click="viewpress">
                      审批跟踪
                    </el-button>
                  </div>
                  <div style="text-align: center;margin-top: 0.3rem"  v-if="isDetail">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>
                  </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory"
                               :id="instid"/>
                </div>
              </div>
            </div>
          </div>
<!--            <div class="anniu" v-if="!resubmit">
              <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
              </el-row>
            </div>
            <div class="anniu" v-else="resubmit">
              <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
                <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
              </el-row>
            </div>-->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import ss from "../../../api/SystemService";
export default {
  data(){
    return {
      appealData:{},
      q:{
      },
      taskid:null,
      instid:null,
      showhistory:false,
      daquflag:false,
      resubmit: false,
      refid: this.$util.getUuid(),
      agentList: {},      //签约经销商
      isSf:true,
      isQuyu:false,
      isDetail:false,
      isEnd:false,
    }
  },
  filters: {
  },
  methods: {
    handleFilter(){
      this.querypage();
    },
    choseSelected(){
    },
    pass(aaa){
      this.appealData.taskid=this.$route.query.taskid;
      this.appealData.aaa=aaa;
      this.appealData.auditMind2=this.appealData.auditMind2;
      this.appealData.instid=this.$route.query.instid;
      this.appealData.ywid=this.$route.query.ywid;
      ss.grabOrderApi.orderAppealPass(this.appealData).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },
    daquPass(aaa){
       this.appealData.taskid=this.$route.query.taskid;
       this.appealData.aaa=aaa;
       this.appealData.auditMind2=this.appealData.auditMind2;
       this.appealData.instid=this.$route.query.instid;
       this.appealData.ywid=this.$route.query.ywid;
      ss.grabOrderApi.orderAppealPass(this.appealData).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/orderAppeal'
      })
    },
    //提交
    saveOrSubmit(v){
      this.appealData.isZc = v;
      this.appealData.refid = this.refid;
      console.log(v);
      ss.grabOrderApi.orderAppealAdd(this.appealData).then(res => {
        console.log(res)
        if (res.f) {
          this.$msg.msgs("提交成功！");
          this.$router.push("/orderAppeal");
        } else {
          this.$msg.msge("提交失败！" + res.msg);
        }
      })
    },
    //重新提交
    resaveOrSubmit(){

    },
    showComList(data){
      if(data == "" ){
            return;
      }
      ss.grabOrderApi.selectByUserNameAppela(data).then(rd=>{
        this.agentList ={},
        console.log("rd",rd)
        if(rd.obj.length > 0){
          this.agentList = rd.obj;
        }else {
          this.agentList = [
            {
              "customerName1" : data,
            }
          ]
          console.log("rd",this.agentList)
        }

      })
    },
    showComList1(value){
      console.log("value",value);

    },
    selectByInstidAppela(instid){
      ss.grabOrderApi.selectByInstidAppela(instid).then(rd=>{
            console.log("rd",rd)
            this.appealData = rd.obj;
            this.refid = rd.obj.refid;
      })
    },
    getTaskById(taskId){
      ss.grabOrderApi.getTaskById(taskId).then(rd=>{
        console.log("rd.name",rd)
        if(null != rd.msg){
          if(rd.msg.name == '窜货方区域' || rd.msg.name == '窜货方大区' || rd.msg.name == '平台'){
            this.isSf = false;
          }
          if(rd.msg.name == '窜货方区域'){
            this.isQuyu = true;
          }
          if(rd.msg.name == '申诉方区域确认'){
            this.isEnd = true;
          }
        }
      })
    },
  },
  created(){
    this.instid = this.$route.query.instid;
    this.refid = this.appealData.refid;
    this.selectByInstidAppela(this.$route.query.instid);
    console.log("this.$route.query.instid",this.$route.query.instid)
    if(null != this.$route.query.instid && null != this.$route.query.taskid){
      this.isDetail = false;
    }else {
      this.isDetail = true;
    }
    this.getTaskById(this.$route.query.taskid);


  },
  computed: {
  },
  props: {
  }
}
</script>

<style scoped>
.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
</style>
<style>
.file {
  width: 50%;
  margin-left: 50px;
}
</style>